import { Clock, RotateCcw, ShieldCheck, Truck } from 'lucide-react';

const BADGES = [
  { icon: Clock, title: 'Delivered in under 60 minutes', description: 'Fast, reliable delivery windows.' },
  { icon: ShieldCheck, title: '100% quality guarantee', description: 'Fresh products, every order.' },
  { icon: RotateCcw, title: 'Easy returns', description: 'Hassle-free returns on eligible items.' },
  { icon: Truck, title: 'Free delivery over ₹499', description: 'No delivery fee on qualifying orders.' },
] as const;

/** Static delivery-promise / trust badges -- standard grocery-storefront copy, not fabricated product/order data. */
export function TrustBadgesSection() {
  return (
    <section className="bg-gray-50/70 py-10 sm:py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <h2 className="mb-5 text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">Our delivery promise</h2>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          {BADGES.map((badge) => (
            <div
              key={badge.title}
              className="flex flex-col items-start gap-3 rounded-2xl border border-gray-100 bg-white p-4 transition duration-300 hover:-translate-y-1 hover:shadow-md"
            >
              <span className="bg-brand/15 flex h-11 w-11 items-center justify-center rounded-full">
                <badge.icon className="text-brand-foreground h-5 w-5" aria-hidden="true" />
              </span>
              <p className="text-sm font-semibold text-gray-900">{badge.title}</p>
              <p className="text-xs text-gray-500">{badge.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
